import React from "react";

const styles = {
  HIGH: "bg-[#DCFCE7] text-[#166534] border-[#22C55E]",
  MEDIUM: "bg-[#FEF9C3] text-[#854D0E] border-[#EAB308]",
  LOW: "bg-[#FEE2E2] text-[#991B1B] border-[#EF4444]",
  FAILED: "bg-[#FEE2E2] text-[#991B1B] border-[#EF4444]",
  OVERRIDE: "bg-neutral-900 text-white border-neutral-900",
};

export default function ConfidenceBadge({ tier, score, className = "" }) {
  const t = (tier || "FAILED").toUpperCase();
  const cls = styles[t] || styles.FAILED;
  return (
    <span
      data-testid={`confidence-badge-${t.toLowerCase()}`}
      className={`inline-flex items-center gap-2 px-2 py-1 border font-mono text-[10px] uppercase tracking-[0.18em] font-semibold ${cls} ${className}`}
    >
      <span className="inline-block w-1.5 h-1.5 rounded-full bg-current" />
      {t}
      {typeof score === "number" && score > 0 && (
        <span className="opacity-60">{score.toFixed(2)}</span>
      )}
    </span>
  );
}
